import {PopoverProps, PopoverActions, Popover as MPopover} from "@mui/material";
import {useCallback, useRef} from "react";

export function Popover(props: PopoverProps) {
    const actionsRef = useRef<PopoverActions>(null);
    const paperRef = useCallback((node: HTMLDivElement | null) => {
        if (!node) return;
        const observer = new ResizeObserver(() => {
            requestAnimationFrame(() => actionsRef.current?.updatePosition());
        });

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    const {slotProps, ...rest} = props;

    return (
        <MPopover
            action={actionsRef}
            slotProps={{
                ...slotProps,
                paper: {
                    ref: paperRef,
                    ...(typeof slotProps?.paper === "object" ? slotProps.paper : {}),
                },
            }}
            {...rest}
        />
    );
}
